import { useCallback, useEffect, useState } from "react";
import { AssinaturaApi } from "../../hooks/assinaturaApi";
import { InfoAssinatura } from "../../types/Assinatura";
import { AssinaturaContext } from "./AssinaturaContext";

export const AssinaturaProvider = ({ children }: { children: JSX.Element }) => {
  const [info, setInfo] = useState<InfoAssinatura | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const carregar = useCallback(async () => {
    try {
      const dados = await AssinaturaApi().getInfoAssinatura();
      setInfo(dados);
    } catch (error) {
      console.error("Erro ao carregar info de assinatura no provider:", error);
      // Não bloqueia o app — fluxoNovo fica null, consumidores tratam.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return (
    <AssinaturaContext.Provider
      value={{
        info,
        fluxoNovo: info?.fluxo_novo ?? null,
        loading,
        refresh: carregar,
      }}
    >
      {children}
    </AssinaturaContext.Provider>
  );
};
